import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngxs/store';
import { AvailabilityStatus } from './../../../../../../../../_shared/enums/treatment/availabilityStatus.enum';
import { TreatmentNote } from './../../../../../../../../_shared/model/treatment/treatment-notes.model.';
import { Notes, Term } from './../../../../../../../../_shared/state/treatment/treatment.actions';

@Component({
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: '[trt-wid-m-note-i-header]',
    templateUrl: './trt-wid-m-note-i-header.component.html',
    styleUrls: ['./trt-wid-m-note-i-header.component.scss'],
})
export class TrtWidMNoteIHeaderComponent implements OnInit {
    @Input()
    data: TreatmentNote;

    @Input()
    isFormDirty = false;

    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix, @typescript-eslint/no-explicit-any
    public onSave: EventEmitter<any> = new EventEmitter();

    public availabilityStatus: typeof AvailabilityStatus = AvailabilityStatus;

    constructor(public store: Store) {}

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method, @typescript-eslint/no-empty-function
    ngOnInit() {}

    public toggleExpand(): void {
        this.store.dispatch(new Term.ToggleDetails(this.data.internalId));
    }

    public removeNote(): void {
        this.store.dispatch(new Notes.RemoveNote(this.data));
    }

    public updateNote(): void {
        this.onSave.emit();
        this.isFormDirty = false;
    }
}
